<template>
  <v-container fluid class="px-0 py-0">
    <v-tabs show-arrows>
      <v-tab>出车前</v-tab>
      <v-tab>行车中</v-tab>
      <v-tab>收车后</v-tab>
      <v-tabs-items>
        <v-tab-item>
          <vehicle-check-cfg :cfg="{cfgId: firstCfg.id, enableInform: true }" v-if="firstCfg" />
        </v-tab-item>
        <v-tab-item>
          <vehicle-check-cfg :cfg="{ cfgId: middleCfg.id, enableInform: true }" v-if="middleCfg" />
        </v-tab-item>
        <v-tab-item>
          <vehicle-check-cfg :cfg="{cfgId: lastCfg.id, enableInform: true }" v-if="lastCfg" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>
<script>
const VehicleCheckCfg = () => import("../views/vehicle-check-cfg.vue");
export default {
  name: "vehicle-three-check-cfg",
  components: {
    VehicleCheckCfg,
  },
  data() {
    return {
      groups: [],
      id: null,
      firstCfg: null,
      middleCfg: null,
      lastCfg: null,
    };
  },
  methods: {
    init() {
      let self = this;
      self.$axios
        .get("/home/admin/m/my/tenant/vehicle/check/cfg/three/cfgs")
        .then((r) => {
          //判断有还是没有，如果没有直接创建
          let defaults = r.data.defaults || {};
          for (let cfg of r.data.message) {
            if (cfg.type == 1) {
              self.firstCfg = cfg;
            } else if (cfg.type == 2) {
              self.middleCfg = cfg;
            } else if (cfg.type == 3) {
              self.lastCfg = cfg;
            }
          }

          if (!self.firstCfg) {
            self.createCfg(1, defaults[1]);
          }

          if (!self.middleCfg) {
            self.createCfg(2, defaults[2]);
          }

          if (!self.lastCfg) {
            self.createCfg(3, defaults[3]);
          }
        });
    },
    createCfg(type, cfgs) {
      let self = this;
      self.$axios
        .post(
          `/home/admin/m/my/tenant/vehicle/check/cfg/create`,
          self.$qs.stringify({
            type: type,
            name: type == 1 ? "三检出车前" : type == 2 ? "三检行车中" : "三检收车后",
            published: true,
            checkerPhoto: false,
            _cfgs: cfgs
          })
        )
        .then((r) => {
          if (r.data.status == "ok") {
            self[type == 1 ? "firstCfg" : type == 2 ? "middleCfg" : "lastCfg"] =
              r.data.message;
          }
        });
    },
  },
  created() {
    this.init();
  },
};
</script>
